import { Routes } from '@angular/router';
import { AuthguardService } from '../authguard.service';
import {SearchComponent} from './search/search.component';

export const searchRoutes: Routes = [
    {
        // path: 'search/:query',
        path: 'search',
        component: SearchComponent,
        canActivate: [AuthguardService]
    }
];



// WEBPACK FOOTER //
// ./src/app/search/search.routes.ts